export default Object.freeze({
    CELSIUS: 'Celsius (°C)',
    FAHRENHEIT: 'Fahrenheit (°F)',
});
